import { useNavigate } from 'react-router-dom';
import * as hook from '../hooks/export';
import * as style from '../utils/general_style';
import * as links from '../utils/general_links';
import * as formData from '../utils/form_data';
import inputValidator from '../utils/form_functions';
import * as form from '../components/form/export';

function Devis() {
    const [checked, setChecked] = hook.useCheckState();
    const [devisType, devisTypeHandler] = hook.useRadioState();
    const [fieldSize, fieldSizeHandler] = hook.useRadioState();
    const [portalSize, portalSizeHandler] = hook.useRadioState();
    const [network, networkHandler] = hook.useRadioState();

    const aboutFieldInputs = formData.allInputs.filter(input => input.forms.includes('apropos'));
    const detailsInputs = formData.allInputs.filter(input => input.forms.includes('coordonnees'));
    const multipleRadio = [{handler: fieldSizeHandler, value: fieldSize}, {handler: portalSizeHandler, value: portalSize}, {handler: networkHandler, value: network}];

    const page = 'devis';
    const saveInputValue = (e) => {
        sessionStorage.setItem(`${page}_${e.target.name}`, e.target.value);
    };

    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        setTimeout(function() {
            navigate(links.ROUTES.home)
        }, 800);
    };

    const allDevisInputs = [...aboutFieldInputs, ...detailsInputs];
    const [validationState, setValidationState] = hook.useValidationState(allDevisInputs);
    const validateInputData = (e) => {
        let isValidated = inputValidator(e.target.name, e.target.value);
        setValidationState(prevState => ({...prevState, [e.target.name]: isValidated}));
    };

    const isValidated = (type, name) => {
        let validate;
        if (type === 'devided') {
            validate = (validationState[(name==='contact') ? 'codePostal':'codePostalTerrain'] && validationState[(name==='contact') ? 'ville':'villeTerrain']) ? '0' : '1';
        } else {
            validate = validationState[name] ? '0' : '1';
        }
        return validate;
    };
    
	return (
        <div className='AppBody noCTABar'>
            <form method='post' onSubmit={ handleSubmit }>
			    <section style={style.ELEMENT_BLOCK_WHITE}>
                    <div style={{...style.COLUMN_CENTER, width: '100%'}}>
                        <h1 style={style.TITLE}>Je réalise mon devis</h1>
                        <div style={{...style.ROW_SPACE_BETWEEN, margin: `${style.SPACE.extraSmall} 0px`}}>
                            {formData.typeDevis.map(({label, value}, index) => (
                                <form.RoundRadio label={ label } onChange={ devisTypeHandler } name={ value } isSelected={ devisType === value } value={ value } key={ index } />
                            ))}
                        </div>
                    </div>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>À propos du terrain</legend>
                        <div style={{...style.ROW_SPACE_BETWEEN, width: '100%'}}>
                            <div style={{...style.COLUMN_START}}>
                                {aboutFieldInputs
                                    .filter(inputs => inputs.type !== 'radio')
                                    .map(({ label, name, type, required, options, devidedInputs }, index) => (
                                        <form.CustomInput label={ label } type={ type } name={ name } required={ required } onChange={ saveInputValue } onBlur={ e => validateInputData(e) } validationState={ isValidated(type, name) } keyword={ page } form={ 'apropos' } options={ options } devidedInputs={ devidedInputs } list={ true } key={ index } />
                                    ))
                                }
                            </div>
                            <div style={{...style.COLUMN_START, width: '48%', minHeight: '272px', justifyContent: 'space-between'}}>
                                {aboutFieldInputs
                                    .filter(inputs => inputs.type === 'radio')
                                    .map(({ title, answers }, index) => (
                                        <div key={ index } style={{height: '79px', width: '100%'}}>
                                            <p style={{marginBottom: style.SPACE.medium}}>{ title }</p>
                                            <div style={style.ROW}>
                                                {answers.map(({label, value}, new_index) => (
                                                    <div style={{width: '100%', maxWidth: '200px'}} key={ new_index }>
                                                        <form.RoundRadio label={ label } onChange={ multipleRadio[index].handler } name={ value } isSelected={ multipleRadio[index].value === value } value={ value } key={ new_index } />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </fieldset>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>Coordonnées</legend>
                        <div style={{...style.ROW_SPACE_BETWEEN, width: '100%', flexWrap: 'wrap'}}>
                            {detailsInputs.map(({ label, name, type, required, options, devidedInputs }, index) => (
                                <form.CustomInput label={ label } type={ type } name={ name } required={ required } onChange={ saveInputValue } onBlur={ e => validateInputData(e) } validationState={ isValidated(type, name) } keyword={ page } form={ 'apropos' } options={ options } devidedInputs={ devidedInputs } size={ (detailsInputs.length === index + 1 && ((index + 1) % 2) !== 0) ? 'full' : '' } key={ index } />
                            ))}
                        </div>
                    </fieldset>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>Documents à fournir</legend>
                        <div style={{width: '100%'}}>
                            {formData.docsToSend.map(({ label, name, legend }, index) => 
                                <div key={ index } style={{...style.COLUMN_START, width: '100%', marginBottom: style.SPACE.medium}}>
                                    <label htmlFor={ name } style={{marginBottom: style.SPACE.small}}>{ label }</label>
                                    <input name={ name } id={ name } type='file' style={{border: `1px solid ${style.COLORS.grey}`, borderRadius: '3px', width: '100%', maxWidth: '48%', height: '40px'}} />
                                    {legend && <span>{ legend }</span> }
                                </div>
                            )}
                        </div>
                    </fieldset>
                        <div style={{cursor: 'pointer', margin: `${style.SPACE.medium} 0px`}}>
                            <form.Checkbox id='devisConditions' checked={ checked } onChange={ setChecked } label={<p style={{fontSize: '14px', textAlign: 'center'}}>En soumettant ce formulaire, j'accepte que les informations saisies soient utilisées pour me recontacter, je reconnais avoir pris connaissance de votre politique de confidentialité et j'accepte les conditions générales de vente.</p>} />
                        </div>
                        <div style={{...style.ROW_CENTER, width: '100%', margin: `${style.SPACE.medium} 0px`}}>
                            <form.SubmitButton label={ 'Envoi' } clear={ page } />
                        </div>
                        <div style={{...style.ROW_END, margin: `${style.SPACE.small} 0px`}}>
                            <form.RequiredSpan required={ true } /><p>informations requises</p>
                        </div>
                </section>
            </form>
        </div>
	);
};

export default Devis;